import React from 'react';
import { useDispatch } from 'react-redux';

import { pushParams } from 'dpl/actions/query_params';
import Button from 'dpl/common/design_system/Button';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES
} from 'dpl/constants/analytics';
import { getAnalyticsOrigin } from 'dpl/shared/utils/getAnalyticsOrigin';
import { setAnalyticsOrigin } from 'dpl/shared/utils/setAnalyticsOrigin';

export default function UserHeaderLoggedOutV2() {
  const { LOGIN, SIGNUP_INTRO } = SIGNUP_FORM_TYPES;
  const dispatch = useDispatch();
  const LOGIN_TEXT = 'Login';
  const SIGNUP_TEXT = 'Sign up';

  function handleTrackClick({ buttonCta }) {
    const analyticsOrigin = getAnalyticsOrigin();
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      button_cta: buttonCta,
      view: analyticsOrigin.origin_view,
      view_feature_location: ANALYTICS_VIEW_FEATURES.NAVIGATION_BAR
    });
    // We set the analytics origin after because we want where this is sent to have these origins
    setAnalyticsOrigin({
      origin_view_feature_location: ANALYTICS_VIEW_FEATURES.NAVIGATION_BAR
    });
  }
  return (
    <div className="flex gap-8 items-center">
      <Button
        variant="outline"
        onClick={() => {
          handleTrackClick({ buttonCta: LOGIN_TEXT });
          dispatch(pushParams({ direct_signup: LOGIN }, { hash: true }));
        }}
      >
        {LOGIN_TEXT}
      </Button>
      <Button
        // We have to set the border top to 0 to make this look visually the same height as the login text
        style={{ borderTop: 0 }}
        variant="primary"
        onClick={() => {
          handleTrackClick({ buttonCta: SIGNUP_TEXT });
          dispatch(pushParams({ direct_signup: SIGNUP_INTRO }, { hash: true }));
        }}
        className="nowrap"
      >
        {SIGNUP_TEXT}
      </Button>
    </div>
  );
}
